/**
 * Turns on the custodian UI, which hides the pages, tabs and actions that a firm holding its own custody (such as ii)
 * doesn't use.
 */
export const CUSTODIAN_UI_FEATURE_FLAG = 'seccl-37484-custodian-ui';
